import React from "react";
import { Box, Typography } from "@material-ui/core";
import { useSelector } from "react-redux";

import Spacer from "components/Spacer";
import PercentageIndicator from "components/visuals/PercentageIndicator";

import { selectors } from "modules/customer/insights/portfolio/performanceDrivers/storeSize";

const SalesPerPoundOfPropertyCostVariance = () => {
    const salesPerPoundOfPropertyCostVariance = useSelector(state => selectors.salesPerPoundOfPropertyCostVariance(state));
    const { loading, error, value } = salesPerPoundOfPropertyCostVariance;
    const label = "% variance from median";

    return (
        <Box display="flex" data-cy="sales-per-pound-of-property-cost-variance">
            <Typography variant="body1">{label}</Typography>
            <Spacer />
            <PercentageIndicator loading={loading} error={error} align="right" showIndicator={false} value={value} />
        </Box>
    );
};

export default SalesPerPoundOfPropertyCostVariance;
